module.exports = __webpack_public_path__ + "img/winner-page-napi.7aa8e30f.png";